import { createSharedComposable, ref, useTimeoutFn } from '#imports'

const JACKPOT_LABEL_MS = 3_000
const JACKPOT_AMOUNT_MS = 5_000

// Single shared cycle so every jackpot tile flips its label/amount in sync.
export const useJackpotCycle = createSharedComposable(() => {
    const phase = ref<'label' | 'amount'>('label')

    if (import.meta.client) {
        const delay = ref(JACKPOT_LABEL_MS)
        const { start } = useTimeoutFn(() => {
            phase.value = phase.value === 'label' ? 'amount' : 'label'
            delay.value = phase.value === 'label' ? JACKPOT_LABEL_MS : JACKPOT_AMOUNT_MS
            start()
        }, delay, { immediate: true })
    }

    return { phase }
})
